document.addEventListener('DOMContentLoaded', function () {
	const accommodationCheckbox = document.getElementById('id_job-accommodation_required');
	const accommodationDetails = document.getElementById('accommodationDetails');

	if (!accommodationCheckbox || !accommodationDetails) {
		return;
	}

	if (accommodationCheckbox.checked) {
		accommodationDetails.style.display = 'block';
	}

	accommodationCheckbox.addEventListener('change', function () {
		if (this.checked) {
			accommodationDetails.style.display = 'block';
		} else {
			accommodationDetails.style.display = 'none';
		}
	});
});